import { Grid, InputAdornment, Typography } from "@mui/material";
import {
  FastCheckboxField,
  FastTextField,
  FastSelectFieldSingle,
  FastPhoneField,
  ImageUploadField,
  SelectMultipleChipField,
} from "../CustomReactHookFields";
import { useGetAccessoriesQuery, useGetServicesbyProviderQuery } from "features/services/servicesApiSlice";
import { useState, useEffect } from "react";
import DOMPurify from "dompurify"; 
export const GetFields = ({ fields, disabled = false, control, id, setValue, watch }) => {
  const { data: services, isLoading: isLoadingServices } = useGetServicesbyProviderQuery({ id });
  const { data: accessories, isLoading: isLoadingAccessories } = useGetAccessoriesQuery({ id });

  const answers = watch();

  const filteredFields = fields.filter((item) => {
    const skipLogic = item.skip_logics || [];
    return skipLogic.every((logic) => {
      const answer = answers[logic.target_question_id];

      if (logic.condition_type === "WAS_ANSWERED") {
        if (answer === undefined) {
          return false;
        }

        switch (logic.comparison_type) {
          case "EQUALS":
            return answer == logic.expected_value;
          case "NOT_EQUALS":
            return answer != logic.expected_value;
          case "IS_GREATER_THAN":
            return Number(answer) > Number(logic.expected_value);
          case "IS_LESS_THAN":
            return Number(answer) < Number(logic.expected_value);
          case "IS_GREATER_THAN_OR_EQUAL_TO":
            return Number(answer) >= Number(logic.expected_value);
          case "IS_LESS_THAN_OR_EQUAL_TO":
            return Number(answer) <= Number(logic.expected_value);
          case "ANY":
            return true;
          default:
            return true;
        }
      }

      return true;
    });
  });

  const [imageLink, setImageLink] = useState("");

  return (
    <>
      {filteredFields.map((item, index) => {
        const commonProps = {
          key: index,
          label: item.question,
          name: item.id.toString(),
          disabled,
          control,
          required: item?.is_required,
        };

        switch (item.question_type) {
          case "PARAGRAPH_TEXT":
            return (
              <Grid item xs={10} lg={6} key={index} sx={{width:"100%"}}>
                <FastTextField {...commonProps} type="text" />
              </Grid>
            );
          case "NUMBER":
            return (
              <Grid item xs={10} lg={6} key={index} sx={{width:"100%"}}>
                <FastTextField {...commonProps} type="number" />
              </Grid>
            );
          case "EMAIL":
            return (
              <Grid item xs={10} lg={6} key={index} sx={{width:"100%"}}>
                <FastTextField {...commonProps} type="email" />
              </Grid>
            );
          case "PHONE":
            return (
              <Grid item xs={10} lg={6} mb={2} key={index} sx={{width:"100%"}}>
                <FastPhoneField {...commonProps} />
              </Grid>
            );
          case "MULTIPLE_CHOICE":
            return (
              <Grid item xs={10} lg={6} key={index} sx={{width:"100%"}}>
                <SelectMultipleChipField options={item?.choices} {...commonProps} />
              </Grid>
            );
          case "SINGLE_CHOICE":
            return (
              <Grid item xs={10} lg={6} key={index} sx={{width:"100%"}}>
                <FastSelectFieldSingle options={item?.choices} {...commonProps} />
              </Grid>
            );
          case "LINK":
            return (
              <Grid item xs={10} lg={6} key={index} sx={{width:"100%"}}>
                <FastTextField type="url" {...commonProps} />
              </Grid>
            );
          case "IMAGE_BASE64_HEX":
            return (
              <Grid item xs={10} lg={6} key={index} sx={{width:"100%"}}>
                <ImageUploadField {...commonProps} />
              </Grid>
            );
          case "IMAGE_LINK":
            return (
              <Grid item xs={10} lg={6} key={index} sx={{width:"100%"}}>
                <FastTextField
                  {...commonProps}
                  type="url"
                  onChange={(e) => {
                    const value = e.target.value;
                    setImageLink(value);
                    setValue(item.id.toString(), value); // Update form value
                  }}
                  InputProps={{
                    startAdornment: imageLink ? (
                      <InputAdornment position="start">
                        <img
                          src={imageLink}
                          alt="Preview"
                          style={{ width: 40, height: 40, borderRadius: "4px" }}
                        />
                      </InputAdornment>
                    ) : null,
                  }}
                />
              </Grid>
            );
          case "ADDITIONAL_TERMS_AND_CONDITIONS":
            return (
              <Grid  key={index} sx={{width: "100%"}}>
                <FastCheckboxField options={[item.question]} {...commonProps} />
              </Grid>
            );
            case "LABEL":

              return (
          
  
    <Grid
   
      key={index}
      display="flex"
      sx={{ justifyContent: "flex-start",
        width: {
          md: "50%", 
          xs: "80%",  
        },
     }}
    >
      <Typography
        component="div"
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.question) }}
        sx={{ width: "100%", mb: 2, textAlign: "left", color: 'grey !important' }}
      />
    </Grid>
  
 
              );
          default:
            return null;
        }
      })}
    </>
  );
};
